import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

const typographyExamples = [
  {
    className: 'text-h1',
    name: 'Heading 1',
    description: 'text-3xl font-semibold',
    example: 'Die größte Überschrift für Haupttitel',
  },
  {
    className: 'text-h2',
    name: 'Heading 2',
    description: 'text-2xl font-bold',
    example: 'Wichtige Sektionsüberschriften',
  },
  {
    className: 'text-h3',
    name: 'Heading 3',
    description: 'text-xl font-bold',
    example: 'Unterabschnitte und Kategorien',
  },
  {
    className: 'text-h4',
    name: 'Heading 4',
    description: 'text-xl font-semibold',
    example: 'Kleinere Überschriften',
  },
  {
    className: 'text-h5',
    name: 'Heading 5',
    description: 'text-lg font-semibold',
    example: 'Kompakte Überschriften',
  },
  {
    className: 'text-h6-medium',
    name: 'Heading 6 Medium',
    description: 'text-base font-medium',
    example: 'Kleinste Überschrift - Medium',
  },
  {
    className: 'text-h6-semibold',
    name: 'Heading 6 Semibold',
    description: 'text-base font-semibold',
    example: 'Kleinste Überschrift - Semibold',
  },
  {
    className: 'text-body-1',
    name: 'Body 1',
    description: 'text-sm font-bold',
    example: 'Hervorgehobener Fließtext für wichtige Informationen',
  },
  {
    className: 'text-body-2',
    name: 'Body 2',
    description: 'text-sm font-medium',
    example: 'Standard Fließtext für normalen Inhalt und Beschreibungen',
  },
  {
    className: 'text-caption',
    name: 'Caption',
    description: 'text-xs font-semibold',
    example: 'Bildunterschriften und kleine Labels',
  },
];

export function TypographyShowcase() {
  return (
    <div className='space-y-8 p-6 max-w-6xl mx-auto'>
      <div className='text-center space-y-4'>
        <h1 className='text-h1'>SWD Typografie</h1>
        <p className='text-body-2'>Alle verfügbaren Textstile des SWD Vouchershop Design Systems</p>
      </div>

      {/* Typography Section */}
      <Card>
        <CardHeader>
          <CardTitle>Typografie</CardTitle>
          <CardDescription>Alle verfügbaren Textstile mit der Outfit-Schriftart</CardDescription>
        </CardHeader>
        <CardContent>
          <div className='grid gap-6'>
            {typographyExamples.map(item => (
              <div key={item.className} className='flex flex-col space-y-2 p-4 border rounded-lg bg-neutral-weiss/50'>
                <div className='flex items-center justify-between'>
                  <span className='text-caption text-neutral-grau'>{item.name}</span>
                  <code className='text-caption text-neutral-grau bg-neutral-hellgrau px-2 py-1 rounded'>
                    {item.className}
                  </code>
                </div>
                <div className={cn(item.className)}>{item.example}</div>
                <span className='text-caption text-neutral-mittelgrau'>{item.description}</span>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* Usage Examples */}
      <Card>
        <CardHeader>
          <CardTitle>Anwendungsbeispiele</CardTitle>
          <CardDescription>Praktische Beispiele für die Verwendung der Typografie</CardDescription>
        </CardHeader>
        <CardContent>
          <div className='space-y-8'>
            {/* Article Example */}
            <div className='space-y-4'>
              <h2 className='text-h2'>Beispiel-Artikel</h2>
              <p className='text-body-2'>
                Dies ist ein Beispiel für normalen Fließtext. Der Text verwendet die Outfit-Schriftart und ist optimal
                für längere Textpassagen geeignet.
              </p>
              <h3 className='text-h3'>Unterüberschrift</h3>
              <p className='text-body-1'>Hervorgehobener Text für wichtige Informationen oder Akzente im Text.</p>
              <div className='text-caption text-neutral-grau'>Bildunterschrift oder zusätzliche Informationen</div>
            </div>

            {/* Form Example */}
            <div className='space-y-4 border-t pt-8'>
              <h3 className='text-h4'>Formular-Beispiel</h3>
              <div className='space-y-3'>
                <div>
                  <label className='text-body-1 block mb-1'>Benutzername</label>
                  <div className='text-body-2 text-neutral-grau'>Geben Sie Ihren gewünschten Benutzernamen ein</div>
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
